import { isElderlyUserRole } from "@/shared/lib/roles";
import type { AppRole } from "@/shared/store/authStore";

export type AccountNavigationItem = {
  href: string;
  label: string;
};

export function isVerifiedProvider(status?: string | null) {
  return status?.toUpperCase() === "VERIFIED";
}

export function getAccountNavigation(role?: AppRole | null, options?: { providerVerified?: boolean }): AccountNavigationItem[] {
  if (isElderlyUserRole(role)) {
    return [
      { label: "Dashboard", href: "/user/dashboard" },
      { label: "Book Care", href: "/user/book-appointment" },
      { label: "My Bookings", href: "/user/bookings" },
      { label: "Family Members", href: "/user/patients" },
      { label: "Visit History", href: "/user/booking-history" },
      { label: "Profile", href: "/user/profile" },
      { label: "Settings", href: "/user/settings" },
    ];
  }

  if (role === "provider") {
    if (!options?.providerVerified) {
      return [{ label: "Complete Registration", href: "/provider/onboarding" }];
    }

    return [
      { label: "Dashboard", href: "/provider/dashboard" },
      { label: "Schedule", href: "/provider/schedule" },
      { label: "Appointments", href: "/provider/appointments" },
      { label: "Visit History", href: "/provider/booking-history" },
      { label: "Payments", href: "/provider/payments" },
      { label: "Profile", href: "/provider/details" },
    ];
  }

  if (role === "admin") {
    return [
      { label: "Dashboard", href: "/admin/dashboard" },
      { label: "Bookings", href: "/admin/bookings" },
      { label: "Providers", href: "/admin/providers" },
      { label: "Users", href: "/admin/users" },
      { label: "Services", href: "/admin/services" },
      { label: "Finance", href: "/admin/finance" },
      { label: "Documents", href: "/admin/documents" },
      { label: "Refunds", href: "/admin/refunds" },
      { label: "Legal Terms", href: "/admin/legal" },
      { label: "Platform Contents", href: "/admin/platform-contents" },
      { label: "Settings", href: "/admin/settings" },
    ];
  }

  if (role === "super_admin") {
    return [
      { label: "Dashboard", href: "/super-admin/dashboard" },
      { label: "Users", href: "/super-admin/users" },
      { label: "Providers", href: "/super-admin/providers" },
      { label: "Bookings", href: "/super-admin/bookings" },
      { label: "Services", href: "/super-admin/services" },
      { label: "Finance", href: "/super-admin/finance" },
      { label: "Payments", href: "/super-admin/payments" },
      { label: "Refunds", href: "/super-admin/refunds" },
      { label: "Legal Terms", href: "/super-admin/legal" },
      { label: "Platform Contents", href: "/super-admin/platform-contents" },
      { label: "Settings", href: "/super-admin/settings" },
      { label: "Admin Access", href: "/super-admin/admin-access" },
      { label: "Audit Logs", href: "/super-admin/audit-logs" },
    ];
  }

  return [];
}
